import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import APIManager from 'modules/common/apiManager';
import Select from 'react-select-plus';
import {
    Button,
    ButtonCommonTheme,
    FormControl,
    Table,
    Label,
    FormGroup,
    ControlLabel
} from 'modules/theme';
import {
    ModalFooter,
    FormWrapper,
    FormColumn,
} from 'modules/theme';

export class UserMapSkillAddEdit extends Component {

    constructor(props) {
        super(props);
        this.saveData = this.saveData.bind(this);
        this.renderFormGroup = this.renderFormGroup.bind(this);
        this.mAPI = new APIManager();
        this.state = {
            name: '',
            score: '',
        };
    }

    renderFormGroup(label, props) {
        return (
            <FormGroup>
                <ControlLabel required={props.required}>{label}</ControlLabel>
                <FormControl {...props} />
            </FormGroup>
        );
    }

    apiResponse(errorCode, data) {
        if (errorCode === 201) {
            // Alert.success(`${data.message}`);
            let message = data && data.message ? data.message : 'Successfully Done';
            Alert.success(`${message}`);
            this.setData();
            this.props.closeModal(true);
        } else {
            // Alert.error(`${data.message}`);
            let message = data && data.message ? data.message : 'Something wrong happened';
            Alert.error(`${message}`);
        }
    }


    saveData(e) {
        e.preventDefault();
        let _this = this;
        let Name = this.state.name || "";
        Name = Name.trim();
        let tData = {
            name: Name,
            type: this.state.type,
            score: 1
        };

        this.mAPI.sendPostAPI(
            `${this.moduleUrl}`,
            tData,
            data => {
                _this.setData();
                _this.props.closeModal(true);
                Alert.success(`${this.moduleName} is Created.`);
            },
            (errorCode, data) => {
                this.apiResponse(errorCode, data);
            }
        );
    }

    generateParams(tData) {
        console.log('dd', tData)
        return tData.map(tData => ({
            value: tData._id,
            label: tData.name
        }));
    }

    render() {
        const { modalType } = this.props;
        const exceptThisSymbols = ["e", "E", "-", "."];
        console.log('State Data', this.state);
        return (
            <form onSubmit={e => this.saveData(e)}>
                <FormWrapper>
                    <FormColumn>
                        {/* {this.renderFormGroup('name', {
                            defaultValue: '',
                            autoFocus: true,
                            required: true,
                            id: 'name',
                            value: this.state.name,
                            onChange: e => {
                                if (e.target.value === ' ') {
                                    return false;
                                }
                                this.setState({ name: e.target.value });
                            }
                        })} */}
                        {this.props.listData ? <FormGroup>
                            <ControlLabel>Name</ControlLabel>
                            {/* <Select
                                placeholder="Select a name"
                                onChange={items => {
                                    this.setState({ name: items.value });
                                }}
                                multi={true}
                                value={this.state.name}
                                options={this.generateParams(this.props.listData)}
                            /> */}
                            <Select
                                placeholder={('Select name')}
                                onChange={selectedOption => {
                                    this.setState({
                                        name: selectedOption
                                    });
                                }}
                                value={this.state.name}
                                options={this.generateParams(this.props.listData)}
                                multi
                            />
                        </FormGroup> : <FormGroup>
                            <ControlLabel>Name</ControlLabel>
                            {/* <Select
                                placeholder="Select a name"
                                onChange={items => {
                                    this.setState({ name: items.value });
                                }}
                                multi={true}
                                value={this.state.name}
                                options={this.generateParams(this.props.listData)}
                            /> */}
                            <Select
                                placeholder={('Select name')}
                                onChange={selectedOption1 => {
                                    this.setState({
                                        name: selectedOption1
                                    });
                                }}
                                value={this.state.name}
                                options={this.generateParams(this.props.listData1)}
                                multi
                            />
                        </FormGroup>}

                    </FormColumn>
                </FormWrapper>
                <FormWrapper>
                    <FormColumn>
                        {this.renderFormGroup('score', {
                            defaultValue: '',
                            autoFocus: false,
                            required: true,
                            type: 'number',
                            id: 'score',
                            value: this.state.score,
                            onKeyDown: e => {
                                exceptThisSymbols.includes(e.key) && e.preventDefault()
                            },
                            onChange: e => {
                                this.setState({ score: e.target.value });
                            }
                        })}
                    </FormColumn>
                </FormWrapper>

                <ModalFooter modalType={modalType}>
                    <ButtonCommonTheme
                        type='greyModalBtn'
                        btnStyle="cancel"
                        OnClick={() => this.props.closeModal()}
                        size="xl"
                    >
                        Cancel
                    </ButtonCommonTheme>
                    <ButtonCommonTheme
                        type="blueModalBtn"
                        btnType="submit"
                        btnStyle="default"
                        size="xl"
                        style={{ float: 'right' }}
                    >
                        Add
                    </ButtonCommonTheme>
                </ModalFooter>
            </form>
        );
    }
}

UserMapSkillAddEdit.propTypes = {
    group: PropTypes.array
};

UserMapSkillAddEdit.contextTypes = {
    __: PropTypes.func,
    closeModel: PropTypes.func.isRequired
};

export default UserMapSkillAddEdit


// WEBPACK FOOTER //
// src/modules/screens/settings/UserMapSkill/components/UserMapSkillAddEdit.js